import React from 'react';
import { Activity } from 'lucide-react';
import WhyPanel from './WhyPanel';

/**
 * MovementWhyPanel — synthesized WHY for the /performance page. Reads
 * `movement_insight` from /api/wellness/iq (built by compute_movement_insight
 * in wellness.py). Same shape and look as RecoveryWhyPanel.
 */
const MovementWhyPanel = ({ insight, score, onActionClick }) => (
  <WhyPanel
    insight={insight}
    icon={Activity}
    color="#CCFF00"
    title={`WHY YOUR MOVEMENT IS${score != null ? '' : ' WHERE IT IS'}`}
    score={score}
    testIdPrefix="movement-why-panel"
    onActionClick={onActionClick}
    emptyMessage="I need a few more signals to talk specifics. Log today's check-in (body energy + pain) and run a mobility scan — then I can point at the real lever."
  />
);

export default MovementWhyPanel;
